// btw-front/src/pages/PartnerPending.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import Container from "../components/ui/Container";
import { usePartnerSession } from "../context/PartnerSessionContext";

export default function PartnerPending() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { signupToken, role, clearSignupToken, logout } = usePartnerSession();

  function handleClose() {
    if (signupToken) clearSignupToken();
    if (role === "pending") logout();
    navigate("/partners", { replace: true });
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1 py-16 md:py-24">
        <Container>
          <div className="mx-auto max-w-xl">
            <div className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm md:p-12">
              <div
                aria-hidden="true"
                className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 text-2xl"
              >
                ⏳
              </div>
              <h1 className="mt-5 text-xl font-bold text-slate-900 md:text-2xl">
                {t("partners.pending.title")}
              </h1>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                {t("partners.pending.desc")}
              </p>
              {/* 기존 회사 가입 — 승인되면 그 회사에 계정이 추가된다는 점을 알린다 */}
              {signupToken && signupToken.requestKind === "member" && (
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {t("partners.pending.memberHint", { company: signupToken.companyName || "-" })}
                </p>
              )}
              {signupToken && (
                <p className="mt-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] leading-relaxed text-amber-900">
                  {t("partners.pending.viaTokenHint")}
                </p>
              )}
              <div className="mt-7">
                <button type="button" onClick={handleClose} className="btw-btn-ghost">
                  {t("partners.pending.close")}
                </button>
              </div>
            </div>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
